import { render, staticRenderFns } from "./DmqAddressForm.vue?vue&type=template&id=0f5c493f&"
import script from "./DmqAddressForm.vue?vue&type=script&lang=ts&"
export * from "./DmqAddressForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports